import React, { ChangeEvent } from 'react';
import { Language } from '../types';
import { languages } from '../data/languages';

interface LanguageSelectorProps {
  value: string;
  onChange: (e: ChangeEvent<HTMLSelectElement>) => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ value, onChange }) => {
  return (
    <div>
      <h2>Select your primary language:</h2>
      <select value={value} onChange={onChange}>
        <option value="">Select a language</option>
        {languages.map((lang: Language) => (
          <option key={lang.code} value={lang.code}>{lang.name}</option>
        ))}
      </select>
    </div>
  );
};

export default LanguageSelector;